import React from 'react';
import {Grid, Fab, Typography, withWidth} from '@material-ui/core';
import {ArrowForward, FiberManualRecord} from '@material-ui/icons';
import {withStyles} from '@material-ui/core/styles';
import {isWidthUp} from '@material-ui/core/withWidth';
import {Fade} from 'react-reveal';

const imagePath = '/images/hero.svg';
const styles = theme => ({
  introductionContent: {
    padding: `${theme.spacing.unit * 20}px ${theme.spacing.unit * 15}px`,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 8,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    },
    paddingRight: 0
  },
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },
  title: {
    fontWeight: 'bold'
  },
  subTitle: {
    lineHeight: 1.2
  },
  description: {
    color: theme.palette.text.secondary
  },
  image: {
    maxWidth: '100%',
  },
  tryNowButton: {
    fontSize: theme.spacing.unit * 1.5,
    minWidth: 150,
    marginTop: theme.spacing.unit * 2,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  question: {
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing.unit * 9
  },
  letsTalkLink: {
    color: theme.palette.primary.light
  },
  bulletIcon: {
    color: theme.palette.primary.light,
    paddingRight: theme.spacing.unit
  }
});

const Introduction = withStyles(styles)(({classes, width}) => {

  const image = (
    <Grid item xs md={6} lg={6}>
      <Fade right duration={1500} distance="75%">
        <img src={imagePath} className={classes.image} alt="Hero"/>
      </Fade>
    </Grid>
  );

  return (
    <div className={classes.root}>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Fade left duration={1500} distance="75%">
            <Grid container direction="column" justify="center" alignItems="flex-start"
                  className={classes.introductionContent}>
              <Grid item>
                <Typography variant="caption" color="secondary" gutterBottom className={classes.tagLine}>
                  Trading | Payments | Investments | Commerce
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} gutterBottom
                            className={classes.title}>
                  The Internet of Money
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} gutterBottom
                            className={classes.subTitle}>
                  Built on Blockchain, Fueled by Crypto
                </Typography>
              </Grid>
              <Grid item>
                <Typography gutterBottom variant="body2" className={classes.description}>
                  CryptX Financial is a Crypto Finance ecosystem built to enable a global, decentralized economy. Learn
                  how
                  you
                  can access the Markets of the world using Cryptocurrencies.
                </Typography>
              </Grid>
              <Grid item>
                <Fab variant="extended" size="large" color="secondary" className={classes.tryNowButton}>
                  Try Now
                  <ArrowForward fontSize="small"/>
                </Fab>
              </Grid>
              <Grid item>
                <Typography variant="caption" className={classes.question}>
                  <FiberManualRecord fontSize="small" className={classes.bulletIcon}/>
                  If you’d like to Invest with us, &nbsp;
                  <a href="#" className={classes.letsTalkLink}>Let’s setup a meeting!</a>
                </Typography>
              </Grid>
            </Grid>
          </Fade>
        </Grid>
        {isWidthUp('md', width) && image}
      </Grid>
    </div>
  );
});


export default withWidth()(Introduction);
